import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';

import moment from 'moment';
import { SaveBatteryData, UpdateBatteryData } from './ActionCreator';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
export default function Add({ editData, handleEditingData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [objectData, setObjectData] = useState({
        productCode: "",
        brand: "",
        modelName: "",
        capacityAh: "",
        voltageV: "",
        batteryType: "",
        warrantyMonths: "",
        price: "",
        manufactureDate: moment(new Date()).format("YYYY-MM-DD"),
        expiryDate: moment(new Date()).format("YYYY-MM-DD"),
        description: "",
    })

    const inputField = [
        { label: "Product Code", value: objectData?.productCode, type: "text", name: "productCode" },
        { label: "Brand", value: objectData?.brand, type: "text", name: "brand" },
        { label: "Model Name", value: objectData?.modelName, type: "text", name: "modelName" },
        { label: "Capacity (Ah)", value: objectData?.capacityAh, type: "text", name: "capacityAh" },
        { label: "voltage (v)", value: objectData?.voltageV, type: "text", name: "voltageV" },
        { label: "Battery Type", value: objectData?.batteryType, type: "text", name: "batteryType" },
        { label: "Warrenty Months", value: objectData?.warrantyMonths, type: "number", name: "warrantyMonths" },
        { label: "Price", value: objectData?.price, type: "number", name: "price" },
        { label: "Manufacture Date", value: objectData?.manufactureDate, type: "date", name: "manufactureDate" },
        { label: "Expire Date", value: objectData?.expiryDate, type: "date", name: "expiryDate" },
        { label: "Description", value: objectData?.description, type: "text", name: "description" },
    ]

    useEffect(() => {
        if (editData?.id) {
            setObjectData({
                productCode: editData?.productCode || "",
                brand: editData?.brand || "",
                modelName: editData?.modelName || "",
                capacityAh: editData?.capacityAh || "",
                voltageV: editData?.voltageV || "",
                batteryType: editData?.batteryType || "",
                warrantyMonths: editData?.warrantyMonths || "",
                price: editData?.price || "",
                manufactureDate: editData?.manufactureDate || moment(new Date()).format("YYYY-MM-DD"),
                expiryDate: editData?.expiryDate || moment(new Date()).format("YYYY-MM-DD"),
                description: editData?.description || "",
            })
        } else {
            setObjectData({
                productCode: "",
                brand: "",
                modelName: "",
                capacityAh: "",
                voltageV: "",
                batteryType: "",
                warrantyMonths: "",
                price: "",
                manufactureDate: moment(new Date()).format("YYYY-MM-DD"),
                expiryDate: moment(new Date()).format("YYYY-MM-DD"),
                description: "",
            })
        }
    }, [])


    const handlechange = (e, type) => {
        const { value } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const handleSave = () => {
        let obj = { ...objectData }
        if (editData?.id) {
            obj.id = editData?.id;
            setLoader(true)
            UpdateBatteryData(obj, callback => {
                setLoader(false)
                console.log("cal", callback)
                if (callback?.message == "success" && callback?.status == 200) {
                    setPopup({ show: true, popupStatus: "Data Updated Successfully" })

                } else {
                    setPopup({ show: true, popupStatus: "Error Updating Data" })

                }
                removePopup()
            })
            handleEditingData({})

        } else {
            setLoader(true)
            SaveBatteryData(obj, callback => {
                setLoader(false)
                console.log("cal", callback)
                if (callback?.message == "success" && callback?.status == 200) {
                    setPopup({ show: true, popupStatus: "Data Added Successfully" })

                } else {
                    setPopup({ show: true, popupStatus: "Error Adding Data" })

                }
                removePopup()
            })
        }
        setObjectData({
            productCode: "",
            brand: "",
            modelName: "",
            capacityAh: "",
            voltageV: "",
            batteryType: "",
            warrantyMonths: "",
            price: "",
            manufactureDate: moment(new Date()).format("YYYY-MM-DD"),
            expiryDate: moment(new Date()).format("YYYY-MM-DD"),
            description: "",
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div style={{ padding: '0 20px', marginTop: '40px' }}>
                <div style={{ borderRadius: '8px', boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', margin: '5px auto', padding: '20px 15px' }}>
                    <div className="row">
                        {
                            inputField ? inputField?.map((value, id) => {
                                if (value?.name == "password") return null
                                return (
                                    <div className="col-sm-4 col-xs-12" key={id}>
                                        <TextField sx={{ margin: '15px 0' }} fullWidth id="standard-basic" label={value?.label} variant="standard" value={value?.value} type={value?.type} onChange={(e) => handlechange(e, value?.name)} />
                                    </div>
                                )
                            })
                                : ''}


                    </div>


                    <div style={{ textAlign: 'center', margin: '10px 0' }}>
                        <button className="btn btn-primary" onClick={() => handleSave()}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}
